import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';

import {MessageModel} from '../models/message.model';
import {BACKEND_KEYS, URL_CONSTANT, BACKEND_METHOD_TYPES, BACKEND_METHOD_CONSTANT} from './url-constant';
import {UserModel} from '../models/user.model';
import {AuthService} from './auth.service';
import 'rxjs/add/operator/catch';
import {throwError} from 'rxjs';


@Injectable()
export class BaseAPI {

  public baseUrl = environment.apiUrlMaster;
  public logsUrl = environment.apiUrlLogs;
  public masterUrl = environment.newApiUrlMaster;
  public pangyoBaseUrl = environment.pangyoApiUrl;
  public profileUrl = environment.profileApiUrl;
  public nipaUrl = environment.apiUrlNipa;

  // headers: HttpHeaders = new HttpHeaders()
  //   .append('Content-Type', 'application/json')
  //   .append('Access-Control-Allow-Origin', '*');
  //
  // headers = new HttpHeaders({'Content-Type':['application/json;
  // charset=utf-8', 'text/plain', 'text/json', 'text/javascript', 'text/html', 'multipart/form-data'],
  //   'Access-Control-Allow-Headers': ['Origin', 'X-Requested-With', 'Content-Type', 'Accept']});


  constructor(public http: HttpClient, public authService: AuthService) {
  }

  public handleError(error: any) {
    console.log(error);
    const message = new MessageModel('Bad request', 'bad request');
    if (error instanceof HttpErrorResponse) {
      const response = error as HttpErrorResponse;
      message.status = response.statusText;
      message.message = response.error.message;
      // console.log(message);
    }
    return throwError(message);
  }

  private getUrl(url: string = ''): string {
    return this.baseUrl + url;
  }
  private getProfileUrl(url: string = ''): string {
    return this.profileUrl + url;
  }
  private getNipaUrl(url: string = ''): string {
    return this.nipaUrl + url;
  }
  private getMasterUrl(url: string = ''): string {
    return this.masterUrl + url;
  }

  private getUrlDirect(url: string = ''): string {
    // return this.pangyoBaseUrl + url;
    return url;
  }

  public getBaseHttpParams(): HttpParams {
    return new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.platformId, String(8));
  }

  public getBaseHttpParamsWithoutPlatform(): HttpParams {
    return new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password);
  }

  public getBaseHttpParamsRemoteReboot(sensorId: number): HttpParams {
    return new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.sensorId, sensorId.toString())
      .set(BACKEND_KEYS.shellCommand, 'sudo reboot');

  }

  public getBaseHttpParamsRemoteExecutedSensor(): HttpParams {
    return new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)
      .set(BACKEND_KEYS.executed, 'false');

  }

  public getBaseHttpParamsDeleteRemoteExecutedSensor(): HttpParams {
    return new HttpParams()
      .set(BACKEND_KEYS.user, this.authService.user.username)
      .set(BACKEND_KEYS.pass, this.authService.user.password)


  }

  public getBaseHttpParamsProfileCounter(url: string): Observable<any> {
    return this.http.get(this.getProfileUrl(url));
  }

  public getBaseHttpParamsNipa(url: string): Observable<any> {
    return this.http.get(this.getNipaUrl(url));
  }

  public putCounter(url: string, data: any): Observable<any> {
    return this.http.put(this.getProfileUrl(url), data);
  }
  public getWithCustomURL(url: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(url, {params: params});
  }

  public get(url: string = '', params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(this.getUrl(url), {params: params});
  }
  public getNipa(url: string = '', params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(this.getNipaUrl(url), {params: params} );
  }
  public getMaster(url: string = '', params: HttpParams = new HttpParams(), headers: HttpHeaders = new HttpHeaders())
    : Observable<any> {
    return this.http.get(this.getMasterUrl(url), { headers, params });
  }

  public getDirect(url: string = '', params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(this.getUrlDirect(url), {params});
  }

  public post(url: string = '', params: HttpParams = new HttpParams(), data?: any): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': ['GET', 'HEAD', 'OPTIONS', 'POST', 'PUT', 'DELETE'],
      'Access-Control-Allow-Headers': ['Access-Control-Allow-Headers',
        'Origin',
        'X-Requested-With',
        'Content-Type',
        'Accept',
        'Access-Control-Request-Method',
        'Access-Control-Request-Headers'],
    });
    data !== null ? headers['Content-Type'] = 'application/json' : headers;
    return this.http.post(this.getUrl(url), data, {headers: headers, params: params});
    // return this.http.post(this.getUrl(url), data, {params: params});
  }
  public counterPost(url: string = '', data?: any): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': ['GET', 'HEAD', 'OPTIONS', 'POST', 'PUT', 'DELETE'],
      'Access-Control-Allow-Headers': ['Access-Control-Allow-Headers',
        'Origin',
        'X-Requested-With',
        'Content-Type',
        'Accept',
        'Access-Control-Request-Method',
        'Access-Control-Request-Headers'],
    });
    data !== null ? headers['Content-Type'] = 'application/json' : headers;
   // return this.http.post(this.getUrl(url), data, {headers: headers, params: params});
    return this.http.post(this.getProfileUrl(url), data );
  }



  public masterServerPost(
    url: string = '',
    params: HttpParams = new HttpParams(),
    data: any = {},
    headers: HttpHeaders = new HttpHeaders()): Observable<any> {
    // some of master server api need auth so i distinguished headers
    if ( headers === null) {
      headers = new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': ['GET', 'HEAD', 'OPTIONS', 'POST', 'PUT', 'DELETE'],
        'Access-Control-Allow-Headers': ['Access-Control-Allow-Headers',
          'Origin',
          'X-Requested-With',
          'Content-Type',
          'Accept',
          'Access-Control-Request-Method',
          'Access-Control-Request-Headers'],
        'Content-Type': 'application/json',
      });
    }

    // console.log(headers);
    return this.http.post(this.getMasterUrl(url), data, {headers: headers, params: params});
    // return this.http.post(this.getUrl(url), data, {params: params});
  }

  public masterServerPatch(url: string = '', params: HttpParams = new HttpParams(), data: any = {}): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': ['GET', 'HEAD', 'OPTIONS', 'POST', 'PUT', 'DELETE', 'PATCH'],
      'Access-Control-Allow-Headers': ['Access-Control-Allow-Headers',
        'Origin',
        'X-Requested-With',
        'Content-Type',
        'Accept',
        'Access-Control-Request-Method',
        'Access-Control-Request-Headers'],
      'Content-Type': 'application/json',
    });
    // console.log(headers);
    return this.http.patch(this.getMasterUrl(url), data, {headers: headers, params: params});
    // return this.http.post(this.getUrl(url), data, {params: params});
  }



  public put(url: string = '', params: HttpParams = new HttpParams(), data: any = {}): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': ['GET', 'HEAD', 'OPTIONS', 'POST', 'PUT', 'DELETE'],
      'Access-Control-Allow-Headers': ['Access-Control-Allow-Headers',
        'Origin',
        'X-Requested-With',
        'Content-Type',
        'Accept',
        'Access-Control-Request-Method',
        'Access-Control-Request-Headers'],
      'Content-Type': 'application/json',
    });
    return this.http.put(this.getUrl(url), data, {headers: headers, params: params});
    // return this.http.put(this.getUrl(url), data, {params: params});
  }

  public delete(url: string = '', params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.delete(this.getUrl(url), {params: params});
  }

  public deleteCounter(id: number): Observable<any> {
    const url = BACKEND_METHOD_CONSTANT.Counter + BACKEND_METHOD_TYPES.Counters + id + '/';
    return this.http.delete(this.getProfileUrl(url));
  }

  public deleteMasterServer(
    url: string = '',
    params: HttpParams = new HttpParams(),
    headers: HttpHeaders = new HttpHeaders()): Observable<any> {
    return this.http.delete(this.getUrl(url) , { headers, params });
  }

  public postDirect(url: string = '', params: HttpParams = new HttpParams(), data: any = {}): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': ['GET', 'HEAD', 'OPTIONS', 'POST', 'PUT', 'DELETE'],
      'Access-Control-Allow-Headers': ['Access-Control-Allow-Headers',
        'Origin',
        'X-Requested-With',
        'Content-Type',
        'Accept',
        'Access-Control-Request-Method',
        'Access-Control-Request-Headers'],
      'Content-Type': 'application/json',
    });
    return this.http.post(this.getUrlDirect(url), data, {headers: headers, params: params});
    // return this.http.post(this.getUrl(url), data, {params: params});
  }

  public deleteDirect(url: string = '', params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.delete(this.getUrlDirect(url), {params: params});
  }

  public authHeader(username, password): HttpHeaders {
    const httpHeaders = new HttpHeaders({
      Authorization: "Basic " + btoa(username + ":" + password),
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": [
        "GET",
        "HEAD",
        "OPTIONS",
        "POST",
        "PUT",
        "DELETE"
      ],
      "Access-Control-Allow-Headers": [
        "Access-Control-Allow-Headers",
        "Origin",
        "X-Requested-With",
        "Content-Type",
        "Accept",
        "Access-Control-Request-Method",
        "Access-Control-Request-Headers"
      ],
      "Content-Type": "application/json"
    });
    return httpHeaders;
  }
}
